module.exports = __webpack_public_path__ + "static/media/tdb_logo.04bd57ee.svg";